import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/accessPermits";
import Form from "./form";
import List from "./list";

export default function AccessPermits(props) {
    useEffect(() => {
        return () => props.clearParams("admin-access-permits");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Допуски и разрешения"
                            nofilter
                            createBtnText="Добавить допуск"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => <Form {...rest} transition="full" title="Допуск" back={back} source={source} />}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => (
                        <Form {...props} transition="full" title="Добавить допуск" back={back} source={source} />
                    )}
                />
            </Switch>
        </div>
    );
}
